import { createSlice } from "@reduxjs/toolkit";

import {
  saveNewPassword
} from "./actions";
import {
  preAuthentication,
  forgotPassword
} from "../actions";

const initialState = {
  loading: false,
  loadingReset: false,
  userId: null,
  redirect: false
}

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(preAuthentication.fulfilled, (state, action) => {
      state.userId = action.payload.success === true ? action.payload.data.userId : null;
    });

    builder.addCase(saveNewPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.redirect = action.payload.success === true ? true:false;
    });
    builder.addCase(saveNewPassword.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(saveNewPassword.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(forgotPassword.fulfilled, (state, action) => {
      state.loadingReset = false;
    });
    builder.addCase(forgotPassword.pending, (state, action) => {
      state.loadingReset = true;
    });
    builder.addCase(forgotPassword.rejected, (state, action) => {
      state.loadingReset = false;
    });
  }
})

//export const {} = forgotPasswordSlice.actions;
export default resetPasswordSlice.reducer;